import BYOB_CONSTANTS from './BuildYourOwnBundle.constants';

export const setBundleProduct = ({ product, category, isOptional = false }) => ({
  type: isOptional ? BYOB_CONSTANTS.ADD_OPTIONAL_PRODUCT : BYOB_CONSTANTS.ADD_PRODUCT,
  payload: { product, category },
});

export const removeBundleProduct = (payload) => ({
  type: BYOB_CONSTANTS.REMOVE_PRODUCT,
  payload,
});

export const fetchBundleProductDetail = (payload) => ({
  type: BYOB_CONSTANTS.FETCH_BUNDLE_PRODUCT_DETAIL,
  payload,
});

export const onAddByobProduct = (payload) => ({
  type: BYOB_CONSTANTS.ON_ADD_PRODUCT,
  payload,
});

export const setByobProductDetails = (payload) => ({
  type: BYOB_CONSTANTS.SET_BYOB_PRODUCT_DETAILS,
  payload,
});

export const removeProductDetail = (payload) => ({
  type: BYOB_CONSTANTS.REMOVE_PRODUCT_DETAIL,
  payload,
});

export const onAddCategories = (payload) => ({
  type: BYOB_CONSTANTS.SET_CAT,
  payload,
});

export const initBundleCategories = (payload) => ({
  type: BYOB_CONSTANTS.INIT_BUNDLE_CATEGORIES,
  payload,
});

export const addToBagByobProducts = (payload) => ({ type: BYOB_CONSTANTS.ADD_TO_BAG, payload });

export const resetByobState = () => ({ type: BYOB_CONSTANTS.RESET_STATE });

export const setAddedToBagError = (payload) => ({
  type: BYOB_CONSTANTS.SET_ADD_TO_BAG_ERROR,
  payload,
});
